import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AfDataType } from "utils/TableColumnData";
import Select from "react-select";
import handleWheel from "utils/handleOnWheel";
import { ErrorMessage } from "components/ErrorMessage";
import { UseMutateFunction, useMutation } from "@tanstack/react-query";
import { GetCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";

export type AfTableProps = Partial<{
  selectedAwb: any;
  isInnerItemsOpen: any;
  tableData: any[];
  setIsInnerItemsOpen: any;
  setTableData: any;
  product: string;
}>;

const InnerItems: React.FC<AfTableProps> = ({
  tableData = [],
  selectedAwb = 0,
  isInnerItemsOpen,
  setIsInnerItemsOpen,
  setTableData,
  product,
}) => {
  //const [tableData_, settableData_] = useState<any[]>(tableData);

  const [bulkAdd, setBulkAdd] = useState({
    l: "",
    b: "",
    h: "",
    weight: "",
    qty: "",
  });

  useEffect(() => {
    setTableData(tableData);
  }, [tableData]);

  const onInputchange = (e, i, key) => {
    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    _tableData_[selectedAwb].piece[i][key] = e.target.value;
    setTableData(_tableData_);
    console.log(_tableData_);
  };

  const removeLine = (i) => {
    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    _tableData_[selectedAwb].piece.splice(i, 1);
    setTableData(_tableData_);
  };

  const bulkAddLines = () => {
    const qty = parseInt(bulkAdd.qty);
    if (!qty || qty < 1) return;

    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    for (let i = 0; i < qty; i++) {
      _tableData_[selectedAwb].piece.push({
        l: bulkAdd.l,
        b: bulkAdd.b,
        h: bulkAdd.h,
        weight: bulkAdd.weight,
      });
    }
    setTableData(_tableData_);
    
    // Reset bulk add form
    setBulkAdd({
      l: "",
      b: "",
      h: "",
      weight: "",
      qty: "",
    });
  };

  return (
    <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-80 z-10 flex justify-center items-center">
      <div className="bg-white border border-blue-300 p-3 rounded-md shadow-lg max-h-[80vh] overflow-auto">
        <table>
          <tr className="border-b-2 border-black-900 bg-blue-50">
            <td className="px-2 text-center font-semibold" colSpan={2}>
              Bulk Add
            </td>
            <td className="px-1">
              <input
                type="text"
                value={bulkAdd.l}
                onChange={(e) => setBulkAdd({ ...bulkAdd, l: e.target.value })}
                placeholder="L"
                className="w-16 focus:border-black-900 p-1 rounded-md border"
              />
            </td>
            <td className="px-1">
              <input
                type="text"
                value={bulkAdd.b}
                onChange={(e) => setBulkAdd({ ...bulkAdd, b: e.target.value })}
                placeholder="B"
                className="w-16 focus:border-black-900 p-1 rounded-md border"
              />
            </td>
            <td className="px-1">
              <input
                type="text"
                value={bulkAdd.h}
                onChange={(e) => setBulkAdd({ ...bulkAdd, h: e.target.value })}
                placeholder="H"
                className="w-16 focus:border-black-900 p-1 rounded-md border"
              />
            </td>
            <td className="px-1">
              <input
                type="text"
                value={bulkAdd.weight}
                onChange={(e) => setBulkAdd({ ...bulkAdd, weight: e.target.value })}
                placeholder="Weight"
                className="w-16 focus:border-black-900 p-1 rounded-md border"
              />
            </td>
            <td className="px-1 text-center">
              <input
                type="text"
                value={bulkAdd.qty}
                onChange={(e) => setBulkAdd({ ...bulkAdd, qty: e.target.value })}
                placeholder="Qty"
                className="w-16 focus:border-black-900 p-1 rounded-md border"
              />
            </td>
            <td className="px-1">
              <button
                className="rounded-md px-3 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-green-600"
                type="button"
                onClick={bulkAddLines}
              >
                Add
              </button>
            </td>
          </tr>

          <tr>
            <td>&nbsp;</td>
          </tr>
          
          <tr className="border-b border-black-900">
            <td className="px-1 text-center">-</td>
            <td className="border-x text-center px-3">Sr.</td>
            <td className="border-x text-center px-3">L</td>
            <td className="border-x text-center px-3">B</td>
            <td className="border-x text-center px-3">H</td>
            <td className="border-x text-center px-3">Act. Weight</td>
            <td className="border-x text-center px-3">Dim. Weight</td>
            <td className="border-x text-center px-3">Chargable Weight</td>
          </tr>

          {tableData &&
            tableData[selectedAwb]?.piece?.map((a, i) => {
              const prefix = (tableData[selectedAwb].awb_no?.[0] || tableData[selectedAwb].autoGen_product?.[0] || "").toUpperCase();
              const divisor = prefix === "X" ? 2700 : 5000;
              const dimWeight = parseFloat(((a.l * a.b * a.h) / divisor).toFixed(2));
              return (
                <tr className="border-b" key={"pcs-row" + i}>
                  <td className="px-1">
                    <button
                      className="rounded-md w-8 h-8 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-red-600"
                      type="button"
                      onClick={() => {
                        removeLine(i);
                      }}
                    >
                      -
                    </button>
                  </td>
                  <td>
                    <p>{i + 1}</p>
                  </td>
                  <td className="text-center">
                    <input
                      type="text"
                      value={a.l}
                      onChange={(e) => {
                        onInputchange(e, i, "l");
                      }}
                      className="w-16 focus:border-black-900 p-1 rounded-md text-center"
                    />
                  </td>
                  <td className="text-center">
                    <input
                      type="text"
                      value={a.b}
                      onChange={(e) => {
                        onInputchange(e, i, "b");
                      }}
                      className="w-16 focus:border-black-900 p-1 rounded-md text-center"
                    />
                  </td>
                  <td className="text-center">
                    <input
                      type="text"
                      value={a.h}
                      onChange={(e) => {
                        onInputchange(e, i, "h");
                      }}
                      className="w-16 focus:border-black-900 p-1 rounded-md text-center"
                    />
                  </td>
                  <td className="text-center">
                    <input
                      type="text"
                      value={a.weight}
                      onChange={(e) => {
                        onInputchange(e, i, "weight");
                      }}
                      className="w-16 focus:border-black-900 p-1 rounded-md text-center"
                    />
                  </td>

                  <td className="text-right pr-2">
                    <span className="font-medium">
                      {dimWeight}
                    </span>
                  </td>

                  <td className="text-right pr-2 bg-green-200">
                    <span className="font-medium">
                      {Math.max(Number(a.weight), dimWeight)}
                    </span>
                  </td>
                </tr>
              );
            })}

            <tr className="border-b-4">
            <td className="text-center px-3"></td>
            <td className="text-center px-3"></td>
            <td className="text-right px-3" colSpan={3}>Total Weight: </td>
            <td className="border-x text-center px-3">{tableData[selectedAwb]?.piece?.reduce((sum, item) => sum + Number(item["weight"] || 0), 0)}</td>
            <td className="border-x text-center px-3"></td>
            <td className="border-x text-center px-3">
              {parseFloat(tableData[selectedAwb]?.piece?.reduce((sum, item) => {
                const d = ((tableData[selectedAwb].awb_no?.[0] || tableData[selectedAwb].autoGen_product?.[0] || "").toUpperCase()) === "X" ? 2700 : 5000;
                return sum + Math.max(Number(item["weight"] || 0), parseFloat(((item.l * item.b * item.h) / d).toFixed(2)));
              }, 0).toFixed(2))}
            </td>
          </tr>
        </table>
        <div className="text-right">
          <button
            className="rounded-md py-2 px-3 mt-3 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 ml-2"
            type="button"
            onClick={() => {
              setIsInnerItemsOpen(false);
              console.log(tableData);
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export { InnerItems };
